import React from 'react';

import useApi from '@/hooks/useApi';
import { useSlider } from '@/hooks/useSlider';

import { ButtonsSlider } from '@/components/global/ButtonSlider';

import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TInteractionCardClick } from '@/services/requests/Interactions/types';
import { TRecommendation } from '@/services/requests/Recommendation/types/template3';

import { getVisibleCardsIdByElement } from '@/helpers/HtmlHelper/getVisibleCardsIdByElement';

import { Card } from './Card';
import { FixedCard } from './FixedCard';

type TProps = {
  data: TRecommendation;
};

export const Slider = ({ data }: TProps) => {
  const { id, cards, fixed_card } = data;

  const { Api } = useApi();
  const { sliderState, moveSlider, containerRef, checkScrollLimit } = useSlider(
    data,
    'tabName',
    true,
    data.layout,
    'vitrine-template3__card',
  );

  async function handleCardClick(
    event: React.MouseEvent<HTMLAnchorElement>,
    cardId: string,
  ) {
    event.preventDefault();
    const redirectURL = event.currentTarget.href;

    await dispatchInteraction<TInteractionCardClick>(Api, 'card-click', {
      recommendationId: id,
      tabName: 'tabName',
      cardId,
      cardPosition: cards.findIndex(item => item.id === cardId) + 1,
      cards: getVisibleCardsIdByElement(
        containerRef.current as HTMLElement,
        'card-click',
      ),
    }).finally(() => {
      window.location.href = redirectURL;
    });

    return true;
  }

  return (
    <div className="vitrine-template3__slider">
      <>
        <ButtonsSlider
          handleClick={e => moveSlider(e)}
          sliderScroll={sliderState.scroll}
          checkScrollLimit={checkScrollLimit}
          template="3"
        />
        <div
          className="vitrine-template3__cards"
          ref={containerRef}
          data-testid="cards"
        >
          {cards.map(card => (
            <Card
              key={card.id}
              data={card}
              onClick={e => handleCardClick(e, card.id)}
            />
          ))}
          {fixed_card && (
            <FixedCard
              key={fixed_card.id}
              data={fixed_card}
              onClick={e => handleCardClick(e, fixed_card.id)}
            />
          )}
        </div>
      </>
    </div>
  );
};
